import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { LastRefundsInfoCard } from 'components/ItemInfoCard';
import { translate } from 'helpers/intl';
import messages from 'containers/AMCDashboard/LastRefunds/messages';
import { StyledSmallSectionHeader } from 'containers/AMCDashboard/MyContracts/styles';
import { uppercase } from 'utils/string';
import {
  useStyles,
  StyledGrid,
  StyledCard,
  COLOR_BY_REFUND_STATUS,
} from 'containers/AMCDashboard/LastRefunds/styles';
import ItemEmptyState from 'components/ItemEmptyState';
import pages from 'routes/pages';
import { createStructuredSelector } from 'reselect';
import { getIsRefundDetailLoadingSelector } from 'store/sinistre/selectors';
import { connect } from 'react-redux';
import { REFUND_STATUSES } from 'constants/amcStatuses';
import { isEmpty } from 'lodash';

const LastRefunds = ({
  lastRefund,
  refundDetails,
  setDetailsPageBreadcrumbsPath,
  isRefundDetailLoading,
  ...otherProps
}: {
  intl: IntlShape;
  lastRefund: any;
  refundDetails: any;
  setDetailsPageBreadcrumbsPath: Function;
  isRefundDetailLoading: boolean;
}) => {
  const classes = useStyles();

  /* istanbul ignore next */
  const getStatusLabel = () => {
    switch (lastRefund.statusApplication) {
      case REFUND_STATUSES.RETURN:
        return translate({ ...messages.statusReturn }, otherProps);
      case REFUND_STATUSES.VISITE:
        return translate({ ...messages.statusVisite }, otherProps);
      case REFUND_STATUSES.AGREEMENT:
        return translate({ ...messages.statusAgrement }, otherProps);
      case REFUND_STATUSES.REJECTED:
        return translate({ ...messages.statusRejected }, otherProps);
      case REFUND_STATUSES.PAIED:
        return translate({ ...messages.statusPaid }, otherProps);
      case REFUND_STATUSES.PEC_CANCELED:
        return translate({ ...messages.statusPecCanceled }, otherProps);
      case REFUND_STATUSES.PENDING:
        return translate({ ...messages.statusPending }, otherProps);
      case REFUND_STATUSES.COMPLEMENTARY_INFO:
        return translate({ ...messages.statusComplementaryInfo }, otherProps);
      case REFUND_STATUSES.CI_ENCOURS:
        return translate(
          { ...messages.statusPendingComplementaryInfo },
          otherProps,
        );
      case REFUND_STATUSES.PEC:
        return translate({ ...messages.statusPec }, otherProps);
      case REFUND_STATUSES.S_SUITE:
        return translate({ ...messages.statusSSuite }, otherProps);
      default:
        return lastRefund.statusApplication;
    }
  };

  return (
    <>
      <StyledSmallSectionHeader>
        {translate({ ...messages.title }, otherProps)}
      </StyledSmallSectionHeader>
      {!isEmpty(lastRefund) ? (
        <LastRefundsInfoCard
          styles={{ buttonRootStyles: classes.root }}
          firstInformationLabel={translate(
            { ...messages.benficiairy },
            otherProps,
          )}
          secondInformationLabel={translate(
            { ...messages.lossDate },
            otherProps,
          )}
          firstInformationValue={lastRefund.beneficiary}
          secondInformationValue={refundDetails.dateSurvenance}
          buttonLabel={uppercase(
            translate({ ...messages.seeDetails }, otherProps),
          )}
          status={COLOR_BY_REFUND_STATUS[lastRefund.statusApplication]}
          statusApplication={lastRefund.statusApplication}
          statusLabel={getStatusLabel()}
          title={`${uppercase(
            translate({ ...messages.claimNumber }, otherProps),
          )} ${lastRefund.numeroApplication}`}
          redirectionPath={pages.AMC_DETAILS}
          setDetailsPageBreadcrumbsPath={setDetailsPageBreadcrumbsPath}
          isRefundDetailLoading={isRefundDetailLoading}
        />
      ) : (
        <StyledCard>
          <StyledGrid
            container
            textAlign="center"
            alignItems="center"
            justify="center"
            marginBottom="17px"
          >
            <ItemEmptyState
              label={translate({ ...messages.emptyState }, otherProps)}
            />
          </StyledGrid>
        </StyledCard>
      )}
    </>
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    isRefundDetailLoading: false;
  }
>({
  isRefundDetailLoading: getIsRefundDetailLoadingSelector,
});
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(LastRefunds));
